import React from 'react';
import { Table } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/table.less';

export default Table;
